import { IRootState } from '../../../../../store'
import { IWasPatientImmobilizedState } from '../store/wasPatientImmobilized.types'

export const getWasPatientImmbobilizedSelector = (state: IRootState): IWasPatientImmobilizedState =>
  state.wasPatientImmobilized
